export type Permission =
  | 'client.block'
  | 'client.settle'
  | 'client.payment.accept'
  | 'client.invoice.download'
  | 'client.loginAsUser'
  | 'instance.toggles.edit'
  | 'instance.inviteCodes.manage';

export const WILDCARD = '*';

export const ROLE_PERMISSIONS: Record<string, Permission[] | typeof WILDCARD> = {
  Admin: WILDCARD,
  OS: [
    'client.loginAsUser',
    'instance.inviteCodes.manage',
  ],
};
